const ONE_DAY_IN_MS = ( 24 * 60 * 60 * 1000 );


function HasClass( el, cls )
{
    var current = el.getAttribute( "class" );
    return ( ( current != undefined ) && ( current.indexOf( cls ) != -1 ) );
}

function AddClass( el, cls )
{
    if ( el )
    {
        var current = el.getAttribute( "class" );
        if ( ( current == undefined ) || ( current.indexOf( cls ) == -1 ) )
        {
            current += " " + cls;
            el.setAttribute( "class", current );
        }
    }
}
function RemoveClass( el, cls )
{
    if ( el )
    {
        var current = el.getAttribute( "class" );
        if ( current )
        {
            current = current.replace( cls, ' ' );
            el.setAttribute( "class", current );
        }
    }
}
function SearchParentsFor( start, cls, top )
{
    var result;

    var parent = start.parentNode;
    if ( ( parent ) && (  parent.getAttribute ) )
    {
        var pcls = parent.getAttribute( "class" );
        if ( pcls )
        {
            var pclsArray = pcls.split( " " );
            for ( var i = 0; i < pclsArray.length; i++ )
            {
                if ( pclsArray[ i ] == cls )
                {
                    result = parent;
                    break;
                }
            }
        }

        if ( ( !result ) && ( ( !top ) || ( parent != top ) ) )
        {
            result = SearchParentsFor( parent, cls, top );
        }
    }

    return ( result );
}

function cartProductQty( element )
{
    var parent      = SearchParentsFor( element, "bridgman_product_qty-inner-container" );
    var input       = parent.querySelector( "input" );
    var row         = SearchParentsFor( element, "bridgman_cart_item" );
    var variantID   = row.dataset.cartItemId.split( ":" )[ 0 ];
    var lineItem    = row.dataset.cartLineItem;
    // console.log( lineItem )

    if( element.dataset.type == "add" )
    {
        if( input.value < 10 )
        {
            input.value = Number( input.value ) + 1;
        }
    }
    else if( element.dataset.type == "minus" )
    {
        if( input.value > 0 )
        {
            input.value = Number( input.value ) - 1;
        }        
    }
    row.dataset.cartItemQuantity = input.value;
    updateCartProductQty( variantID, input.value );
}

function updateCartProductQty( variant, value )
{
    var xhr     = new XMLHttpRequest( );
    xhr.onreadystatechange = function( )
    {
        if ( xhr.readyState == 4 )
        {
            if ( xhr.status == 200 )
            {
                if( value == 0 )
                {
                    window.location.reload( );
                }
                else
                {
                    UpdateCartPrices(  )
                    console.log( "updated qty successful" + JSON.stringify( xhr ) );
                }
            }
            else
            {
                console.log( "updating qty failed" + xhr.responseText );
            }
        }
    };

    xhr.open( "POST", "/cart/change.js", true );
    xhr.setRequestHeader( "Content-Type", "application/json" );
    xhr.send( JSON.stringify( { "id" : variant, "quantity" : value } ) );
}

function UpdateCartPrices( )
{
    var subTotal        = 0;
    var items           = document.querySelectorAll( ".bridgman_cart_item" );
    var subTotalText    = document.querySelector( ".cart-drawer__subtotal-number" );
    var symbol          = document.querySelector( ".bridgman_cart_drawer-container" ).dataset.shopCurrencySymbol;

    for( var i = 0; i < items.length; i++ )
    {
        var item        = items[ i ];
        var itemQty     = Number( item.dataset.cartItemQuantity );
        var itemPrice   = Number( item.dataset.cartItemPrice );
        var itemTotal   = itemQty * itemPrice;
        subTotal        = subTotal + itemTotal;
    }

    subTotalText.innerHTML = symbol + ( subTotal / 100).toFixed( 2 );
}

function HandlePostcodeInputError( command )
{
    var error = document.querySelector( ".bridgman-postcode-error" );
    
    if( command == "show" )
    {
    	console.log('postcode error')      
        error.classList.remove( "hidden" );
    }
    else if( command == "hide" )
    {
        error.classList.add( "hidden" );
    }
}

function cartFlowNext( element )
{
    window.location.href='/pages/delivery-contact-form';
    return;
    var flowContainers  = document.querySelectorAll( ".bridgman_cart_flow_container" );
    var parent          = SearchParentsFor( element, "bridgman_cart_flow_container" );
    
    function HandleOneFlow( flowIdx )
    {
        if( flowIdx < flowContainers.length )
        {
            var flowContainer = flowContainers[ flowIdx ];
            flowContainer.classList.add( "hidden" );
            if( element.classList.contains( "bridgman-return-to-cart-container" ) ||  element.classList.contains( "return-to-cart" ) )
            {
                if( flowIdx == 0 )
                {
                    flowContainer.classList.remove( "hidden" );
                }
    
                //show upsells
                document.querySelector( ".ajaxifyCart-drawer .featuredcartcolection" ).classList.remove( "hidden" );

                ClearDatePicker();
                HandleOneFlow( flowIdx + 1 );
            }
            else if( flowIdx == ( Number( parent.dataset.flowIndex ) + 1 ) )
            {
                if( element.getAttribute( "id" ) == "bridgman-direct-to-date-button" )
                {
                    CheckForValidPostcode( function()
                    {
                        flowContainer.classList.remove( "hidden" );
                        if( flowContainer.classList.contains( "bridgman_cart_date-selector" ) )
                        {
                            GetAvailableDates( function()
                            {
                                if( flowContainer.querySelectorAll( ".bridgman-option-container" ).length == 1 )
                                {
                                    flowContainer.querySelector( ".bridgman-option-container" ).click(); 
                                }
                    
                                //hide upsells
                                document.querySelector( ".ajaxifyCart-drawer .featuredcartcolection" ).classList.add( "hidden" );
                                                        
                                HandleOneFlow( flowIdx + 1 );
                            } );
                        }
                        else
                        {
                            if( flowContainer.querySelectorAll( ".bridgman-option-container" ).length == 1 )
                            {
                                flowContainer.querySelector( ".bridgman-option-container" ).click(); 
                            }
                
                            //hide upsells
                            document.querySelector( ".ajaxifyCart-drawer .featuredcartcolection" ).classList.add( "hidden" );
                            
                            HandleOneFlow( flowIdx + 1 );
                        }                        
                        // HandleOneFlow( flowIdx + 1 );                    
                    } );
                }
                else
                {
                    flowContainer.classList.remove( "hidden" );
                    if( flowContainer.classList.contains( "bridgman_cart_date-selector" ) )
                    {
                        GetAvailableDates( function()
                        {
                            if( flowContainer.querySelectorAll( ".bridgman-option-container" ).length == 1 )
                            {
                                flowContainer.querySelector( ".bridgman-option-container" ).click(); 
                            }
                
                            //hide upsells
                            document.querySelector( ".ajaxifyCart-drawer .featuredcartcolection" ).classList.add( "hidden" );
                                                    
                            HandleOneFlow( flowIdx + 1 );
                        } );
                    }
                    else
                    {
                        if( flowContainer.querySelectorAll( ".bridgman-option-container" ).length == 1 )
                        {
                            flowContainer.querySelector( ".bridgman-option-container" ).click(); 
                        }
            
                        //hide upsells
                        document.querySelector( ".ajaxifyCart-drawer .featuredcartcolection" ).classList.add( "hidden" );
                        
                        HandleOneFlow( flowIdx + 1 );
                    }
                }
            }
            else if( parent.classList.contains( "bridgman-cart-postcode-picker" ) )
            {
                var input = parent.querySelector( "#cart-flow-postcode-box" )
                if( input.value != "" )
                {
                    HandlePostcodeInputError( "hide" );
                }
                else
                {
                    HandlePostcodeInputError( "show" );
                    this.preventDefault();
                }
                HandleOneFlow( flowIdx + 1 );
            }
            else
            {
                HandleOneFlow( flowIdx + 1 );
            }
        }
    }
    HandleOneFlow( 0 );

    /*
    for( var i = 0; i < flowContainers.length; i++ )
    {
        var flowContainer = flowContainers[ i ];
        flowContainer.classList.add( "hidden" );
        if( element.classList.contains( "bridgman-return-to-cart-container" ) ||  element.classList.contains( "return-to-cart" ) )
        {
            if( i == 0 )
            {
                flowContainer.classList.remove( "hidden" );  
            }

            //show upsells
            document.querySelector( ".ajaxifyCart-drawer .featuredcartcolection" ).classList.remove( "hidden" ); 
        }
        else if( i == ( Number( parent.dataset.flowIndex ) + 1 ) )
        {
            flowContainer.classList.remove( "hidden" );
            if( flowContainer.classList.contains( "bridgman_cart_date-selector" ) )
            {
                GetAvailableDates();
            }
            if( flowContainer.querySelectorAll( ".bridgman-option-container" ).length == 1 )
            {
                flowContainer.querySelector( ".bridgman-option-container" ).click(); 
            }

            //hide upsells
            document.querySelector( ".ajaxifyCart-drawer .featuredcartcolection" ).classList.add( "hidden" );
        }
        else if( parent.classList.contains( "bridgman-cart-postcode-picker" ) )
        {
            var input = parent.querySelector( "#cart-flow-postcode-box" )
            if( input.value != "" )
            {
                HandlePostcodeInputError( "hide" );
            }
            else
            {
                HandlePostcodeInputError( "show" );
                this.preventDefault();
            }
        }
    }
    */
}

function ClearDatePicker()
{
    var calendarContainer   = document.querySelector( ".date-selector-wrapper" );
    var weekContainer       = calendarContainer.querySelector( ".date-selector-week" );
    var previousArrow       = calendarContainer.querySelector( ".date-selector-previous" );
    var nextArrow           = calendarContainer.querySelector( ".date-selector-next" );

    //remove the calendar dates
    weekContainer.innerHTML = "";

    //remove listeners
    $( previousArrow ).off();
    $( nextArrow ).off();
}

function ZeroPad( val )
{
    var result;
    if ( Number( val ) < 10 )
    {
        result = "0" + val;
    }
    else
    {
        result = val.toString( );
    }
    return ( result );
}

function CheckForValidPostcode( cb )
{
    var pc    = document.getElementById( "cart-flow-postcode-box" );
    if( pc && pc.value && pc.value != "" )
    {
        // var post  = { "store" : "{{ shop.permanent_domain }}", "postcode" : pc.value };
        var post  = { "store" : "bridgman-uk.myshopify.com", "postcode" : pc.value };
        SendAPIRequest( "/api/check-postcode", "POST", post, function( err, result )
        {
            if( ( ( result ) && ( ( result.msg ) == "postcode found" ) ) || ( err ) )
            {
                cb();
            }
            else if( ( result ) && ( result.msg ) == "no postcode found" )
            {
                document.getElementById( "bridgman-date-selector-controls" ).classList.add( "hidden" );
                window.location.href = "/pages/delivery-contact-form";                
            }
        } );
    }
    else
    {
        cb();
    }
}

function ItsTheSameDay( d1, d2 )
{
    return ( ( d1.getFullYear( ) == d2.getFullYear( ) ) && ( d1.getMonth( ) == d2.getMonth( ) ) && ( d1.getDate( ) == d2.getDate( ) ) );
}

function GetAvailableDates( cb )
{
    var month     = document.querySelector( ".date-selector-month-controls .date-selector-month" );

    var pc    = document.getElementById( "cart-flow-postcode-box" );
    var param = { "postcode" : pc.value, "items" : g_basket.items };
    SendAPIRequest( "/api/shipping", "POST", param, function( err, result )
    {
        if ( ( result ) && ( result.days ) && ( result.days.length > 0 ) )
        {
            document.getElementById( "bridgman-date-selector-controls" ).classList.remove( "hidden" );
            document.getElementById( "bridgman-no-delivery-message" ).classList.add( "hidden" );

            var dates = [];
            
            // copy over days from the API
            for( var i = 0; i < result.days.length; i++ )
            {
                var date        = {};
                var src         = result.days[ i ];
                date.date       = new Date( src.date );
                date.enabled    = src.enabled;
                date.price      = src.price;
                
                dates.push( date );
                check = date.date;
            }

            // show them all
            ShowAvailableDates( dates );
        }
        else
        {
            document.getElementById( "bridgman-date-selector-controls" ).classList.add( "hidden" );
            // document.getElementById( "bridgman-no-delivery-message" ).classList.remove( "hidden" );
            // console.log(g_basket.items, 'items in basket')
            window.location.href = "/pages/delivery-contact-form";
        }

        if( cb )
        {
            cb();
        }
    } );

    // save the postcode too
    SetCartProperty( "postcode", pc.value );
}

function AddADay( container, entry )
{
    var mainSpan = document.createElement( "span" );
    mainSpan.classList.add('date-wrapper');
    var sp = document.createElement( "span" );
    var dateData = entry.date.getDate( );
    sp.appendChild( document.createTextNode( dateData ) );

    var priceSpan = document.createElement('span');
    priceSpan.classList.add('price-node');
    priceSpan.appendChild( document.createTextNode( "£" + ( entry.price / 100).toFixed( 0 ) ) )
    sp.appendChild(priceSpan);
    
    mainSpan.setAttribute( "data-date", entry.date.toISOString( ) );


    if ( entry.enabled )
    {
        if ( entry.date.getDay( ) == 6 )
        {
            mainSpan.classList.add( "enabled-date" );
            mainSpan.classList.add('saturday-date');
        }
        else
        {
            mainSpan.classList.add( "enabled-date" );
        }
    }
    else if ( entry.placeholder )
    {
        mainSpan.setAttribute( "style", "opacity: 0.1;" );
    }
    mainSpan.appendChild(sp)
    container.appendChild( mainSpan );
}

function AddMonth( container, dates, start )
{
    var first = dates[ start ].date;
    var check = new Date( first );

    // go back to 1st of the month
    while ( check.getDate( ) > 1 )
    {
        check = new Date( check.getTime( ) - ONE_DAY_IN_MS );
    }
    // go back to the previous Sunday
    while ( check.getDay( ) > 0 )
    {
        check = new Date( check.getTime( ) - ONE_DAY_IN_MS );
    }

    // add "disabled" days between then and the start
    while ( !( ItsTheSameDay( check, first ) ) )
    {
        AddADay( container, { "enabled" : false, "date" : new Date( check ), "placeholder" : true } );
        check = new Date( check.getTime( ) + ONE_DAY_IN_MS );
    }
    
    var month;
    for ( var i = start; i < dates.length; i++ )
    {
        var dt = dates[ i ];

        if ( ( month != undefined ) && ( dt.date.getMonth( ) != month ) )
        {
            break;
        }

        AddADay( container, dt );

        if ( ( !dt.placeholder ) && ( !month ) )
        {
            month = dt.date.getMonth( );
            var monthStr = dt.date.toLocaleString( "en-GB", { "month" : "long" } ) + " " + dt.date.getFullYear( );
            container.setAttribute( "data-month", monthStr );
        }
        check = dt.date;
    }

    // add "disabled" days up to the end of the month
    check = new Date( check.getTime( ) + ONE_DAY_IN_MS );
    while ( check.getMonth( ) == month )
    {
        AddADay( container, { "enabled" : false, "date" : new Date( check ), "placeholder" : true } );
        check = new Date( check.getTime( ) + ONE_DAY_IN_MS );
    }

    return ( i );
}

function SetNextPrevState( currentMonth )
{
    if ( currentMonth.previousSibling )
    {
        document.querySelector( ".date-selector-previous" ).classList.remove( "hidden" );
    }
    else
    {
        document.querySelector( ".date-selector-previous" ).classList.add( "hidden" );
    }
    if ( currentMonth.nextSibling )
    {
        document.querySelector( ".date-selector-next" ).classList.remove( "hidden" );
    }
    else
    {
        document.querySelector( ".date-selector-next" ).classList.add( "hidden" );
    }
}

function ShowAvailableDates( dates )
{
    // console.log( "showing dates : " + JSON.stringify( dates ) );

    var container = document.querySelector( ".date-selector-week" );
    var month     = document.querySelector( ".date-selector-month-controls .date-selector-month" );

    while ( container.firstChild )
    {
        container.removeChild( container.firstChild );
    }
    

    var i = 0;
    do
    {
        var monthContainer = document.createElement( "div" );
        var next           = AddMonth( monthContainer, dates, i );
        if ( i == 0 )
        {
            month.innerHTML = monthContainer.getAttribute( "data-month" );
        }
        else
        {
            monthContainer.setAttribute( "class", "hidden" );
        }
        monthContainer.classList.add( "date-selector-month-view" );
        container.appendChild( monthContainer );
        i = next;

    } while ( i < dates.length );

    SetNextPrevState( container.firstChild );

    $( ".date-selector-previous" ).on( "click", HandlePrevMonthDateSelector );
    $( ".date-selector-next" ).on( "click", HandleNextMonthDateSelector );

    $(document ).on( "click", ".enabled-date", function( e )
    {
        
        $( ".date-selector .selected-date" ).removeClass( "selected-date" );
        
        e.currentTarget.classList.add( "selected-date" );
        
        var dateval = new Date( e.currentTarget.getAttribute( "data-date" ) );
        var month   = dateval.getMonth( ) + 1;
        var datestr = dateval.getFullYear( ) + "-" + ZeroPad( month ) + "-" + ZeroPad( dateval.getDate( ) );
        document.querySelector( "input[name='attributes[Delivery-Date]']" ).setAttribute( "value", datestr );
        
        
        document.querySelector( "#bridgman-checkout-button[data-finalcheckout='checkout']" ).classList.remove( "hidden" );
        
        SetDeliveryDate( datestr );
    } );   

    //If you check the calendar on the last day, it shows that month even though no dates are available...
    //check the month and if there are no available dates for that month, go to the next month
    CheckForAvailableDatesInFirstMonth( container.firstChild );
    
    var restock = "";
    var multi   = false;
    
    for ( var i = 0; i < g_basket.items.length; i++ )
    {
        var rd = g_basket.items[ i ].restock;
        if ( i == 0 )
        {
            restock = rd;
        }
        else if ( rd != restock )
        {
            multi = true;
            break;
        }
    }
    if ( multi )
    {
        document.getElementById( "lightning-cart-split-basket-message" ).classList.remove( "hidden" );
    }
    else
    {
        document.getElementById( "lightning-cart-split-basket-message" ).classList.add( "hidden" );
    }
}

function HandleNextMonthDateSelector()
{
    var month = document.querySelector( ".date-selector-month-view:not( .hidden )" );
    var next  = month.nextSibling;
    month.classList.add( "hidden" );
    next.classList.remove( "hidden" );
    document.querySelector( ".date-selector-month-controls .date-selector-month" ).innerHTML = next.getAttribute( "data-month" );
    SetNextPrevState( next );
}

function HandlePrevMonthDateSelector()
{
    var month = document.querySelector( ".date-selector-month-view:not( .hidden )" );
    var prev  = month.previousSibling;
    month.classList.add( "hidden" );
    prev.classList.remove( "hidden" );
    document.querySelector( ".date-selector-month-controls .date-selector-month" ).innerHTML = prev.getAttribute( "data-month" );
    SetNextPrevState( prev );
}

function CheckForAvailableDatesInFirstMonth( month )
{
    var enabledDate = month.querySelector( ".enabled-date" );
    if( !enabledDate )
    {
        document.querySelector( ".date-selector-next" ).click();
    }
}

function SetCartProperty( name, value, cb )
{
    var lineOneQty = 1;

     // g_basket is defined in backend-integration.liquid
    if ( g_basket.items.length > 0 )
    {
        lineOneQty = g_basket.items[ 0 ].qty;
    }

    var post =
    {
        "attributes" : { },
        "line"       : 1,
        "quantity"   : lineOneQty,
        "properties" : { }
    };

    post.attributes[ name ] = value;
    post.properties[ name ] = value;
    jQuery.post( "/cart/change.js", post, cb );
}

function SetDeliveryDate( dateStr )
{
    var lineOneQty = 1;

     // g_basket is defined in backend-integration.liquid
    if ( g_basket.items.length > 0 )
    {
        lineOneQty = g_basket.items[ 0 ].qty;
    }
    var post =
    {
        "line"       : 1,
        "quantity"   : lineOneQty,
        "properties" :
        {
            "_delivery-date" : dateStr
        },
        "attributes" :
        {
            "Delivery-Date"  : dateStr
        }
    };
    jQuery.post( "/cart/change.js", post );
}

function chooseCartOption( element )
{
    var parent          = SearchParentsFor( element, "bridgman_cart_flow_radio_container" );
    var containers      = parent.querySelectorAll( ".bridgman_cart_flow_option" );
    var btn             = document.querySelector( ".bridgman_cart_drawer_part_three .bridgman_cart_drawer_btn" );
    var elInput         = element.querySelector( "input" );
    document.querySelector( ".bridgman_cart_drawer_option_text_container" ).classList.remove( "hidden" );

    for( var i = 0; i < containers.length; i++ )
    {
        var container   = containers[ i ];
        var image       = container.querySelector( "img" );
        var input       = container.querySelector( "input" );
        image.src       = parent.dataset.unselectedImage;
        input.checked   = false;

        if( container  == element )
        {
            image.src       = parent.dataset.selectedImage;
            input.checked   = true;
        }
    }
    //console.log( elInput )

    if( elInput.value == "build" )
    {
        btn.classList.add( "hidden" );
        document.querySelector( "#bridgman-checkout-button2" ).classList.remove( "hidden" );
        
        //btn.innerHTML = "PROCEED TO DELIVERY";
        showCorrectText( elInput.value );
    }
    else if( elInput.value == "dont-build" )
    {
        btn.innerHTML = "CONFIRM AND SELECT DELIVERY";
        showCorrectText( elInput.value );

        if( btn.classList.contains( "hidden" ) )
        {
            btn.classList.remove( "hidden" );
        }
        document.querySelector( "#bridgman-checkout-button2" ).classList.add( "hidden" );
    }

    SetCartProperty( "Build-Option", elInput.value );
} 

function HandleDeliveryOptionClick( btn )
{
    var btns                = document.querySelectorAll( ".bridgman-option-container" );
    var notesContainers     = document.querySelectorAll( ".bridgman-delivery-notes-container" );
    var selectedOption      = btn.querySelector( "input" ).value; 
    var ctaButtons          = document.querySelectorAll( ".cartActionButton .bridgman-flow-btn" );
    var ctaButtonContainer  = document.querySelector( ".cartActionButton" );
    // document.querySelector( "input" ).setAttribute( "checked", "checked" );


    //remove active on div optionBox, uncheck radio
    for( var i = 0; i < btns.length; i++ )
    {
        var button  = btns[ i ];
        var div     = button.querySelector( ".optionBox" );
        var input   = button.querySelector( "input" );

        div.classList.remove( "active" );
        input.removeAttribute( "checked", "checked" );
    }
    //set active on optionBox and check input
    btn.classList.add( "active" );
    btn.querySelector( "input" ).setAttribute( "checked", "checked" );
    
    //show the correct notes
    for( var i = 0; i < notesContainers.length; i++ )
    {
        var container = notesContainers[ i ];
        container.classList.add( "hidden" );
        if( container.dataset.value == btn.querySelector( "input" ).value )
        {
            container.classList.remove( "hidden" );
        }
    }

    //show the correct cta button
    for( var i = 0; i < ctaButtons.length; i++ )
    {
        var cta = ctaButtons[ i ];
        cta.classList.add( "hidden" );
        if( selectedOption ==  "one-man-delivery" )
        {
            //if pre order and restock date - don't take user to select a date, just go to the checkout
            //otherwise show original button
            // if( ctaButtonContainer.dataset.preOrder == "true"  )
            // {
            //     if( cta.dataset.type == "checkout-btn" )
            //     {
            //         cta.classList.remove( "hidden" );
            //     }
            // }
            // else if( cta.dataset.type == "cart-flow-next-btn" )
            // {
            //     cta.classList.remove( "hidden" );
            // }
           if( cta.dataset.type == "cart-flow-next-btn" )
            {
                cta.classList.remove( "hidden" );
            }
        }
        else if( cta.dataset.type == "checkout-btn" )
        {
            cta.classList.remove( "hidden" );
        }
    }
    SetCartProperty( "Delivery-Option", btn.querySelector( "input" ).value );

}

function showCorrectText( value )
{
    var rows = document.querySelectorAll( ".bridgman_cart_drawer_option_text_container_row" );

    for( var i = 0; i < rows.length; i++ )
    {
        var row = rows[ i ];
        if( row.dataset.option == value )
        {
            row.classList.remove( "hidden" );
        }
        else
        {
            row.classList.add( "hidden" );
        }
    }
}

function SetupCarrierSyncHandling( )
{
    window.addEventListener( "load", function( )
    {
        $( "#bridgman-checkout-button" ).on( "click", function( e )
        {
            hj("event","reached_checkout");
        });
        if ( g_basket.checkedOut )
        {
            // this basket has already been to checkout once, so if the date changes then a carrier sync may be needed
            console.log( "starting carrier sync handling" );
        
            $( "#bridgman-checkout-button" ).on( "click", function( e )
            {
                var selected            = document.querySelector( "input[name='attributes[Delivery-Date]']" ).value;
                var selectedDelivery    = document.querySelector( "input[name='attributes[Delivery Option]'][checked='checked']" ).value;
                if( selectedDelivery != "one-man-delivery" )
                {
                    // user has not selected a valid delivery option that requires a date
                    e.preventDefault( );
                    SetCartProperty( "Delivery-Date", "" );
                    SendAPIRequest( "/api/carrier-sync", "POST", { "reset" : true }, function( err, result )
                    {
                        window.location.href = "/checkout?step=contact_information";
                    } );
                }
                else if ( selected != g_basket.deliveryDate )
                {
                    // user has changed the date, need a carrier sync
                    e.preventDefault( );

                    SendAPIRequest( "/api/carrier-sync", "POST", { "reset" : true }, function( err, result )
                    {
                        // can't just do a "normal" advance to checkout as that will probably land straight
                        // on the shipping step and just re-serve the cached rates from the previous day
                        //g_basket.deliveryDate = selected;
                        //$( "#bridgman-checkout-button" ).click( );
                        window.location.href = "/checkout?step=contact_information";
                    } );
                }
            } );
        }
    } );
}

function SetupCartUpdateHandling( )
{
    var timer;
    var observer = new MutationObserver( function( ml, o )
    {
        function DebounceHandler( )
        {
            var xhr = new XMLHttpRequest( );
            xhr.onreadystatechange = function( )
            {
                if ( ( xhr.readyState == 4 ) && ( xhr.status == 200 ) )
                {
                    var parsed;
                    try
                    {
                        //console.log( "rx " + xhr.responseText );

                        if ( xhr.responseText )
                        {
                            parsed = JSON.parse( xhr.responseText );
                            g_basket = parsed;
                        }
                    }
                    catch ( e )
                    {
                        console.log( "error parsing server response : " + e.stack );   
                    }
                }
            };


            console.log( "updating" );
            xhr.open( "GET", "/cart.js", true );
            xhr.setRequestHeader( "Content-Type", "application/json" );
            xhr.send( );
        }

        if ( timer != undefined )
        {
            clearTimeout( timer );
        }
        timer = setTimeout( DebounceHandler, 500 );
    } );
    var watch = document.querySelector( ".bridgman_cart_drawer_part_one" );
    observer.observe( watch, { "childList": true, "subtree" : true } );
}


SetupCarrierSyncHandling( );




window.addEventListener( "load", function( )
{
    SetupCartUpdateHandling( );
    $( "#cart-flow-postcode-box" ).on( "keydown", function( e )
    {
        if ( e.keyCode == 13 )
        {
            e.preventDefault( ); // otherwise enter on the postcode box submits the form, bypassing the date selector
            e.stopPropagation( );

            var next = document.getElementById( "bridgman-direct-to-date-button" );
            if ( next )
            {
                next.onclick( next );
            }
            
            return ( false );
        }
    } );


} );


